export interface ISettingsCategoryVisible {
    category_id: string;
    visible: number;
}
